import TemplateView from '../../TemplateView'

export default class CircleSpinner extends TemplateView {

    constructor({
        additionalClassCircle = '',
        additionalClassContainer = '',
        label =  '',
    } = {}) {
        super()

        this.params = {
            additionalClassCircle,
            additionalClassContainer,
            label,
        }
    }

    templateHtml() {
        return '<div class="circleSpinner">' +
               '    <div class="circlesProgressContainer <%=additionalClassContainer%>">' +
               '        <div class="loadProgressAnimateCircle1 <%=additionalClassCircle%>">' +
               '            <div class="loadProgressAnimateCircle2">' +
               '                <div class="loadProgressAnimateCircle3">' +
               '                    <div class="loadProgressAnimateCircle4"/>' +
               '                </div>' +
               '            </div>' +
               '        </div>' +
               '    </div>' +
               '    <div class="label"><%=label%></div>' +
               '</div>'
    }

    templateModel() {
        return {
            additionalClassCircle: this.params.additionalClassCircle,
            additionalClassContainer: this.params.additionalClassContainer,
            label: this.params.label,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/components/spinner/CircleSpinner.js